import { useCallback, useMemo } from "react";

import { useFiltersScope } from "~/components/filters/FiltersScope";
import type { IRangeValue } from "~/types/range";

export const useVolumeRangeFilter = () => {
  const { filters, updateFilters } = useFiltersScope();

  const initialValue = useMemo(
    () => ({
      min: filters.minVolume,
      max: filters.maxVolume,
    }),
    [filters.maxVolume, filters.minVolume]
  );

  const onChangeVolumeFilter = useCallback(
    (value?: IRangeValue) => {
      updateFilters({ minVolume: value?.min, maxVolume: value?.max });
    },
    [updateFilters]
  );

  return { onChangeVolumeFilter, initialValue };
};
